import styled from 'styled-components';

import { Button } from '@zillow/constellation';

export const StyledButton = styled(Button)`
    white-space: nowrap;
`;
